<template>
	<FormStep
		variant="void"
	>
		<div>
			<VRow
				class="mb-6"
				no-gutters
			>
				<VCol
					cols="auto"
					align-self="center"
				>
					<VIcon
						width="24"
						height="24"
						color="black"
					>
						{{ checkIcon }}
					</VIcon>
				</VCol>
				<VCol>
					<h6
						class="text-h6 ml-4"
					>
						{{ $t('components.simulator.end.title') }}
					</h6>
				</VCol>
			</VRow>
			<VRow
				v-for="(step, index, i) in $t('components.simulator.end.steps')"
				:key="index"
				no-gutters
				class="d-flex mb-4 align-center"
			>
				<VCol
					class="number d-flex justify-center align-center"
					cols="auto"
				>
					{{ i + 1 }}
				</VCol>
				<VCol class="ml-4">
					<p class="text-subtitle-1">
						{{ step.title }}
					</p>
					<p class="text-body-1">
						{{ step.subtitle }}
					</p>
				</VCol>
			</VRow>
		</div>
		<VBtn
			color="primary"
			large
			class="w-100 mt-2"
			:loading="loading"
			@click="next"
		>
			{{ $t('components.simulator.end.cta') }}
		</VBtn>
	</FormStep>
</template>

<script lang="ts">
	import Vue from 'vue';
	import Component, { mixins } from 'vue-class-component';
	import { mapActions } from 'vuex';
	import FormStep from '@/components/FormStep/FormStep.vue';
	import { StateEnum } from '@cnamts/vue-dot/src/constants/enums/StateEnum';
	import { mdiCheckCircleOutline } from '@mdi/js';

	const Props = Vue.extend({
		props: {
			loading: {
				type: Boolean,
				default: false
			}
		}
	});

	const MixinsDeclaration = mixins(Props);

	@Component({
		components: { FormStep },
		methods: {
			...mapActions('notification', ['addNotification'])
		}
	})
	export default class EndStep extends MixinsDeclaration {
		StateEnum = StateEnum;
		checkIcon = mdiCheckCircleOutline;

		next(): void {
			this.$emit('next');
		}
	}
</script>

<style lang="scss"  scoped>
@import '@cnamts/design-tokens/dist/tokens';

.number {
	border-radius: 50%;
	width: 24px;
	height: 24px;
	background-color: $vd-am-blue-base;
	color: white;
}
</style>
